// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CasinoLayoutNavigation_wrapper__FUGHN","floatContainer":"CasinoLayoutNavigation_floatContainer__CjeaK","visible":"CasinoLayoutNavigation_visible__GKHsI"};